import { render, staticRenderFns } from "./CaptainsPayments.vue?vue&type=template&id=b4d59330&scoped=true"
import script from "./CaptainsPayments.vue?vue&type=script&lang=js"
export * from "./CaptainsPayments.vue?vue&type=script&lang=js"
import style0 from "./CaptainsPayments.vue?vue&type=style&index=0&id=b4d59330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d59330",
  null
  
)

export default component.exports